var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
// import VTHotspotControls, { IVTHotspotControlsProps } from "../VTHotspotControls";
import { VTHTMLHotspot } from "./VTHTMLHotspot";
import VTHotspotControls from "../VtHotspotControls";
import { useCallback, useState } from "react";
export function VTHTMLHotspotWithControls(props) {
    var moving = props.moving, borderOn = props.borderOn, editIconAsSettings = props.editIconAsSettings, handleCancelHotspotLocation = props.handleCancelHotspotLocation, handleDeleteHotspotLocation = props.handleDeleteHotspotLocation, handleEditHotspot = props.handleEditHotspot, handleEditHotspotLocation = props.handleEditHotspotLocation, handleSaveHotspotLocation = props.handleSaveHotspotLocation;
    var title = props.title, icon = props.icon, vtRichTextEditorContent = props.vtRichTextEditorContent, onClick = props.onClick, onClose = props.onClose, _a = props.scale2d, scale2d = _a === void 0 ? 1 : _a;
    var _b = __read(useState(null), 2), vtHtmlHotspotContainerWidthHeight = _b[0], setVtHtmlHotspotContainerWidthHeight = _b[1];
    var refVtHtmlHotspotCallback = useCallback(function (vtHtmlHotspotContainer) {
        if (vtHtmlHotspotContainer) {
            setVtHtmlHotspotContainerWidthHeight({
                width: vtHtmlHotspotContainer.clientWidth,
                height: vtHtmlHotspotContainer.clientHeight,
            });
            //     "offset",
            //     vtHtmlHotspotContainerWidthHeight.height - vtHtmlHotspotContainerWidthHeight.height * scale2d,
            // );
        }
    }, [scale2d]);
    return (_jsxs(Box, __assign({ component: "div", sx: __assign({ display: "inline-flex", alignItems: "center", flexDirection: "column", position: "relative" }, props.sx) }, { children: [_jsx(VTHotspotControls, { moving: moving, borderOn: borderOn, editIconAsSettings: editIconAsSettings, handleCancelHotspotLocation: handleCancelHotspotLocation, handleDeleteHotspotLocation: handleDeleteHotspotLocation, handleEditHotspot: handleEditHotspot, handleEditHotspotLocation: handleEditHotspotLocation, handleSaveHotspotLocation: handleSaveHotspotLocation, sx: __assign({ zIndex: 101, position: "absolute", top: "-".concat(40 +
                        (borderOn ? 10 : 0) -
                        (vtHtmlHotspotContainerWidthHeight
                            ? vtHtmlHotspotContainerWidthHeight.height -
                                vtHtmlHotspotContainerWidthHeight.height * scale2d
                            : 0), "px") }, (moving
                    ? {
                        left: "-".concat(70 +
                            (borderOn ? 10 : 0) -
                            (vtHtmlHotspotContainerWidthHeight
                                ? vtHtmlHotspotContainerWidthHeight.width -
                                    vtHtmlHotspotContainerWidthHeight.width * scale2d
                                : 0), "px"),
                    }
                    : {
                        left: "-".concat(110 +
                            (borderOn ? 10 : 0) -
                            (vtHtmlHotspotContainerWidthHeight
                                ? vtHtmlHotspotContainerWidthHeight.width -
                                    vtHtmlHotspotContainerWidthHeight.width * scale2d
                                : 0), "px"),
                    })) }), _jsx(VTHTMLHotspot, { ref: refVtHtmlHotspotCallback, scale2d: scale2d, title: title, icon: icon, vtRichTextEditorContent: vtRichTextEditorContent, onClick: onClick, onClose: onClose })] })));
}
